import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackView = async () => {
      try {
        await fetch(`${API_URL}/api/analytics/pageview`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            page: location.pathname,
            referrer: document.referrer || null,
          }),
        });
      } catch (err) {
        // Silent fail — analytics should never block the user
        if (process.env.NODE_ENV !== "production") {
          console.warn("Analytics tracking failed:", err);
        }
      }
    };
    trackView();
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
